import styles from './Growl.module.css';
import React, { useState, useEffect } from 'react';

const Growl = ({ message, setGrowlMessage }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            setGrowlMessage(null);
        }, 5000);

        return () => clearTimeout(timer);
    }, [message.msg, message.type]);

    return (
            message ?
            (
                    <div className={`${styles.growl} ${styles['growl-' + (message.type ? message.type : 'hide')]}`}>
                        <div className={styles['growl-body']}
                             >                    
                            {message.msg
                            }
                    
                    </div>
                    </div>

                    ) :
            null
            );
};

export default Growl;
